var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-wrap"},[_c('Divider',{style:({ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' })},[_vm._v(_vm._s(_vm.title))]),_c('div',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }